































export default {
  name: 'attachmentsSnackbarAlert',
  props: {
    showSizeValidation: {
      type: Boolean,
      required: true,
      default: false
    },
    showFileTypeValidation: {
      type: Boolean,
      required: true,
      default: false
    },
    showMaxFilesValidation: {
      type: Boolean,
      required: true,
      default: false
    },
    maxFilesToUpload: {
      type: Number,
      required: true,
      default: 0
    },
    fileInputAccept: {
      required: true,
      default: []
    },
    fileIsNotSupported: {
      type: String,
      default: ""
    },
    maxFileSize: {
      type: Number,
      required: true,
      default: 0
    },
    showUploadFilesError: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: {
    maxFileSizeValue() {
      return Math.round(this.maxFileSize / Math.pow(1024, 2)); //fallback to MB
    },
    fileInputAcceptString() {
      return this.fileInputAccept.join(' ');
    }
  },
  methods: {
    dismissAlert() {
      this.$emit("dismissAlert");
    }
  }
};
